module.exports = __webpack_public_path__ + "static/media/raluca_marcu.cf070169.jpg";